import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  width: "120",
  height: "120.000244140625",
  viewBox: "0 0 120 120.000244140625",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M0.000120168 80.0762C0.000120168 87.3474 5.98651 92.732 12.5516 92.8209L23.9895 92.986C34.7078 101.367 45.4331 109.8 56.1472 118.163C62.4578 122.709 71.9916 118.397 71.9916 109.851L71.9916 10.997C71.9916 0.558016 62.7068 -2.98526 56.1472 2.69794C45.4602 11.3208 34.6714 20.0328 23.9543 28.6812L12.5867 28.7574C6.01735 28.8019 0.000120168 34.1801 0 41.4634L0.000120168 80.0762Z",
      fill: "#FFFFFF"
    }, null, -1),
    _createElementVNode("path", {
      d: "M85.7572 43.2418C83.4147 45.7183 83.4147 49.7441 85.7572 52.2204L93.5155 60.4307L85.7572 68.6284C83.4147 71.1111 83.4147 75.1305 85.7572 77.607C88.1003 80.0833 91.899 80.0833 94.2421 77.607L102 69.3967L109.758 77.607C112.101 80.0833 115.9 80.0833 118.243 77.607C120.586 75.1305 120.586 71.1111 118.243 68.6284L110.485 60.4307L118.243 52.2204C120.586 49.7441 120.586 45.7183 118.243 43.2418C115.511 40.3527 111.925 40.9496 109.758 43.2418L102 51.4521L94.2421 43.2418C91.6014 40.4479 88.0859 40.7781 85.7572 43.2418Z",
      fill: "#FFFFFF"
    }, null, -1)
  ]))]))
}
export default { render: render }